import React, { useContext } from "react";

import { useTransition } from "@react-spring/web";
import { env } from "process";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom-v5-compat";

import { Button } from "./Atoms";
import { useBrand } from "./BrandContext";

// This error page is called when the venue is found and we know the branding information
// This means its the global error catching page for everything except the venue not found / loaded correctly

export const ErrorPage = ({
  errorMessage,
  onAction,
  actionMessage,
}: {
  errorMessage?: string;
  onAction: () => void;
  actionMessage?: string;
}) => {
  const venueBrand = useBrand();

  console.log({ env: process.env.NODE_ENV });
  const { t } = useTranslation();
  const inDevelopment = process.env.NODE_ENV === "development";
  return (
    <div
      className="bg-venue-secondary max-h-screen overflow-y-hidden"
      style={venueBrand.cssVariables}
    >
      <div className="opacity-100 pb-96 overflow-y-auto mx-auto sm:max-w-sm h-screen max-w-screen-sm">
        <div className="text-center space-y-16 max-w-screen-lg py-16 md:p-32 mx-auto my-32">
          <h3 className="">{errorMessage || t("errors.general")}</h3>
          <Button primary onClick={onAction}>
            {actionMessage || t("errors.reload")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export const VenueErrorPage = ({
  errorMessage,
  resetError,
}: {
  errorMessage?: string;
  resetError: () => void;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const returnHome = () => {
    resetError();
    navigate("/");
  };

  return (
    <ErrorPage
      errorMessage={errorMessage || t("errors.general")}
      onAction={returnHome}
      actionMessage={t("errors.backToHome")}
    />
  );
};

// This is the true global error page, but in reality only handles incorrectly loaded venues.
// everything else is handled by the VenueErrorPage
export const GlobalErrorPage = ({ errorMessage }: { errorMessage: string }) => {
  return (
    <div className="bg-venue-background max-h-screen overflow-y-hidden">
      <div className="opacity-100 border-b-2 pb-96 overflow-y-auto mx-auto sm:max-w-sm h-screen bg-white max-w-screen-sm">
        <div className="flex flex-wrap space-y-16 content-center justify-center items-center sm:space-x-32 md:space-x-64 max-w-screen-lg py-16 md:p-32 mx-auto my-32">
          <h3 className="">{errorMessage}</h3>
        </div>
      </div>
    </div>
  );
};
